import React from 'react';
import styled from 'styled-components';
import { padding } from 'styled-system';
const Component = styled.div(padding, ({ theme, selected, hasPseudoAfter }) => `
    border: 1px solid
      ${selected ? theme.colors.primary : theme.colors.gray200};
    border-radius: 8px;
    position: relative;
    transition: border-color 0.2s ease-in-out;
    user-select: none;

    & label {
      cursor: pointer;
    }

    &::after {
      border-radius: 8px;
      box-shadow: ${theme.shadows.gray16};
      content: ${hasPseudoAfter ? "''" : 'none'};
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      transition: opacity 0.2s ease-in-out;
      width: 100%;
    };
  `, ({ theme, disabled, onClick }) => {
    if (disabled) {
        return `
        background-color: ${theme.colors.gray200};
        border: 2px solid ${theme.colors.gray200};
        color: ${theme.colors.gray700};
        cursor: not-allowed;
      `;
    }
    if (onClick) {
        return `
        cursor: pointer;
        &:focus::after,
        &:hover::after {
          opacity: 1;
        };
      `;
    }
    return null;
});
export const Card = ({ htmlAttrs, onClick, hasPseudoAfter = true, ...props }) => (React.createElement(Component, { ...Object.assign({}, htmlAttrs, { hasPseudoAfter }, props), onClick: props.disabled ? undefined : onClick }));
//# sourceMappingURL=index.js.map